import React, { useEffect, useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../../../component/call-to-action-button/call-to-action-button';
import { createNewBuildingOperation } from '../operations/create-new-building-operation';

interface AddBuildingDialog {
  branchId: number | undefined;
  closeDialog: () => void;
}

export const AddBuildingDialog: React.FC<AddBuildingDialog> = ({
  branchId,
  closeDialog,
}) => {
  const [buildingName, setBuildingName] = useState('');
  const [loading, setLoading] = useState(false);
  const handleOnSubmit = async () => {
    await createNewBuildingOperation(
      branchId,
      buildingName,
      setLoading,
      closeDialog,
    );
  };
  return (
    <div>
      <EditText title={'שם המבנה'} onChange={setBuildingName} />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'אישור'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
